import React from "react";
import { Checkbox, CheckboxGroup, CheckPicker, Form, FormControl } from "rsuite";

import { debounce } from "utils";
import { FlexGrid, FlexGridItem } from "components/base/FlexGrid";


export default ({ defaultFilter, onChangeFilters, loading, accounts, authInfo }) => {
    const accountSession = authInfo?.session;
    const accountManangedServiceList = accountSession?.account_user?.managed_service_list;

    const filteredAccounts = accounts.filter(item => {
        return item.is_managed && accountManangedServiceList.includes(item.service);
    });

    const formattedAccounts = filteredAccounts.map((account) => {
        return {
            ...account,
            name: `${account.name} / ${account.service}`
        };
    });

    return (
        <Form
            formDefaultValue={defaultFilter}
            onChange={debounce((value) => {
                onChangeFilters(value);
            }, 800)}
        >
            <FlexGrid align="middle">
                <FlexGridItem>
                    <FormControl
                        accepter={CheckPicker}
                        sticky
                        name="account_id_list"
                        data={formattedAccounts}
                        valueKey="id"
                        labelKey="name"
                        placeholder="Accounts"
                        style={{ width: 290 }}
                        menuStyle={{ width: 360 }}
                        disabled={loading}
                    />
                </FlexGridItem>
                <FlexGridItem>
                    <FormControl
                        inline={true}
                        name="status"
                        accepter={CheckboxGroup}
                    >
                        <Checkbox value={0} disabled={loading}>Processing</Checkbox>
                        <Checkbox value={2} disabled={loading}>Passed to financial</Checkbox>
                        <Checkbox value={4} disabled={loading}>Show completed</Checkbox>
                        <Checkbox value={1} disabled={loading}>Show cancelled</Checkbox>
                        <Checkbox value={3} disabled={loading}>Show declined</Checkbox>
                    </FormControl>
                </FlexGridItem>
            </FlexGrid>
        </Form>
    );
};